/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-08 15:41:35
 * @LastEditors: caiqin.xie
 * @message: blog-banner组件
 */
import React from "react";
import styles from "../../index.module.scss";
import { Carousel } from '@arco-design/web-react';
import { useDevice } from "@/hooks";
import { IBanner } from '@/common/types'
import LazyMedia from "@/components/LazyMedia";

interface IProps {
  bannerLists: IBanner[]; // banner列表
}

const Banner = (props:IProps) => {
  const {bannerLists} = props
  const device = useDevice()
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)
  return (
      <>
      { bannerLists && bannerLists.length > 0  &&
        <div className={styles['blog-banner']}>
          <Carousel
            className={styles['banner-carousel']}
            autoPlay={true}
            indicatorType='dot'
            showArrow='hover'>
            {bannerLists && bannerLists.map((item, index) => {
              return (
                <div key={item.id} className={styles["banner-wrap"]}>
                  {
                    item[newDevice].extension === '.mp4'
                    ? <LazyMedia LazyClassName='full-wh' type="video" loop autoPlay preload="auto" playsInline muted src={item[newDevice]?.url}></LazyMedia>
                    : <LazyMedia LazyClassName='full-wh' type="image" src={item[newDevice]?.url} alt={item[newDevice]?.alt} />
                  }
                  <div className={styles["banner-content-wrap"]}>
                    <div className={styles["banner-content"]}>
                      {item?.isShowTitle === 1 && (
                        <h1 className={styles["banner-title"]}>{item?.name}</h1>
                      )}
                      <p className="preLine">{item?.briefIntroduction}</p>
                    </div>
                  </div>
                </div>
              )
            })}
          </Carousel>
        </div>
      }
      </>
  )
}
export default Banner
